import { render, staticRenderFns } from "./TopicCardAnimated.vue?vue&type=template&id=7fff549e&"
import script from "./TopicCardAnimated.vue?vue&type=script&lang=js&"
export * from "./TopicCardAnimated.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports